export const getCdnImage = (imagePathEncoded?: string) =>
    imagePathEncoded ? `${process.env.Images_Base_URL}/${imagePathEncoded}` : "";

export const getAssetsImage = (imagePath: string): string => `${process.env.Assets_Base_URL}/${imagePath}`;
